









exports.default =
  props: ['cssClass','number', 'title', 'type']

  computed:
    convert_number: ->
      return @number if @type == 'not_connected'
      parseInt((@number || 0) / 60)

    suffix: ->
      return 'lig' if @type == 'not_connected'
      'min'




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/voip_report/card.vue